<template>
  <div class="public-site">
    <PublicSiteNav />
    <main>
      <p class="kicker">For venues and general managers</p>
      <h1>Comedy night management</h1>
      <p class="lead">
        We run regular comedy nights. We can help you start and grow one in your room.
      </p>

      <h2>Who we are</h2>
      <p>
        Hilarity Unlimited books and operates club-style comedy nights in London. We look after the
        <em>show</em> so the venue can look after the room: comics who actually turn up, a lineup
        that fits the night, and clear communication all round.
      </p>
      <p>
        We are a small operation - not a national agency. That is the point. You deal with the
        people who book the bills and talk to the comics.
      </p>

      <h2>Nights we already run</h2>
      <ul class="nights-list">
        <li v-for="night in nights" :key="night.name">
          <strong>{{ night.name }}</strong>
          - {{ night.area }} ·
          <PublicNightLink :href="night.mapsUrl" kind="maps">{{ night.place }}</PublicNightLink>
          · {{ night.when }}
          ·
          <PublicNightLink :href="night.eventbriteUrl" kind="tickets">Reserve a seat</PublicNightLink>
        </li>
      </ul>

      <h2>What we take on</h2>
      <ul>
        <li>Finding and booking comics (including new faces and people we already trust)</li>
        <li>Offers, confirmations, and chasing so the bill is actually full on the night</li>
        <li>A sensible mix of spot lengths - not six open-mic slots pretending to be a show</li>
        <li>A named host / shape of the evening so it can become a regular residency</li>
      </ul>

      <h2>What we need from a new room</h2>
      <ul>
        <li>A landlord or GM who wants a <strong>repeating</strong> night, not a single experiment</li>
        <li>A budget that can pay acts properly (even a tight one - we will be honest about what £X buys)</li>
        <li>A space that can hold a crowd and be heard (PA, a corner that becomes "the room")</li>
        <li>A venue we can establish a good working relationship with</li>
      </ul>

      <h2>A first conversation</h2>
      <p>
        {{ contact.name }} · Hilarity Unlimited<br />
        <a :href="contact.mailtoHref">{{ contact.email }}</a><br />
        <a :href="contact.telHref">{{ contact.phone }}</a>
      </p>
    </main>
  </div>
</template>

<script>
/** @see docs/APP_UI_SPEC.md — G2 */
import PublicSiteNav from './PublicSiteNav.vue';
import PublicNightLink from './PublicNightLink.vue';
import { PUBLIC_NIGHTS, PUBLIC_VENUE_CONTACT } from '../utils/publicSite.js';

export default {
  name: 'ForVenuesPage',
  components: { PublicSiteNav, PublicNightLink },
  data() {
    return {
      nights: PUBLIC_NIGHTS,
      contact: PUBLIC_VENUE_CONTACT,
    };
  },
};
</script>

<style scoped>
.public-site {
  min-height: 100vh;
  background: #121214;
  color: #f4efe4;
  text-align: left;
}
main {
  max-width: 720px;
  margin: 0 auto;
  padding: 36px 20px 64px;
}
.kicker {
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.75rem;
  color: #f0c14b;
  margin: 0 0 8px;
}
h1,
h2 {
  color: #f4efe4;
  text-align: left;
}
h1 {
  font-size: 2rem;
  margin: 0 0 12px;
}
h2 {
  font-size: 1.05rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 28px 0 10px;
  border-bottom: 1px solid #3a3732;
  padding-bottom: 6px;
}
.lead,
p,
li {
  color: #d9d0c4;
  line-height: 1.5;
}
.lead {
  font-size: 1.1rem;
  margin: 0 0 8px;
}
ul {
  padding-left: 1.2em;
  list-style: disc;
}
li {
  margin-bottom: 6px;
}
.nights-list {
  list-style: none;
  padding-left: 0;
}
a {
  color: #f0c14b;
}
</style>
